module.exports = __webpack_public_path__ + "img/door-closed.f8e20884.svg";